import React from 'react';

import { KeyOutlined, LockOutlined, SafetyOutlined } from '@ant-design/icons';
import { Form, Input, Row, Col, Alert } from 'antd';
import { useTranslation } from 'react-i18next';

import { useDirtyMaskedField } from '@hooks/shared/useDirtyMaskedField';

const CoupangCredentials = ({ form, ecAccount }) => {
  const { t } = useTranslation();
  const serverIp = document.querySelector('meta[name="server-ip"]')?.content || '';

  const isEditing = !!ecAccount?.id;
  const accessKeyDirty = useDirtyMaskedField(form, [ 'credentials', 'access_key' ], isEditing);
  const secretKeyDirty = useDirtyMaskedField(form, [ 'credentials', 'secret_key' ], isEditing);

  return (
    <div>
      <Alert
        message={`${t('models.ec_account.platform_settings.coupang.ip_whitelist_warning')} IP: ${serverIp}`}
        type="warning"
        showIcon
        style={{ marginBottom: '16px' }}
      />

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name={['credentials', 'vendor_id']}
            label={t('models.ec_account.platform_settings.coupang.vendor_id')}
            rules={[{ required: true, message: t('models.ec_account.platform_settings.coupang.vendor_id_required') }]}
          >
            <Input
              placeholder={t('models.ec_account.platform_settings.coupang.vendor_id_placeholder')}
              prefix={<SafetyOutlined />}
            />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            name={['credentials', 'access_key']}
            label={t('models.ec_account.platform_settings.coupang.access_key')}
            rules={[{ required: true, message: t('models.ec_account.platform_settings.coupang.access_key_required') }]}
          >
            <Input.Password
              autoComplete="new-password"
              placeholder={t('models.ec_account.platform_settings.coupang.access_key_placeholder')}
              prefix={<KeyOutlined />}
              visibilityToggle={accessKeyDirty}
            />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            name={['credentials', 'secret_key']}
            label={t('models.ec_account.platform_settings.coupang.secret_key')}
            rules={[{ required: true, message: t('models.ec_account.platform_settings.coupang.secret_key_required') }]}
          >
            <Input.Password
              autoComplete="new-password"
              placeholder={t('models.ec_account.platform_settings.coupang.secret_key_placeholder')}
              prefix={<LockOutlined />}
              visibilityToggle={secretKeyDirty}
            />
          </Form.Item>
        </Col>
      </Row>
    </div>
  );
};

export default CoupangCredentials;
